import axios from 'axios';
import { IApiResponse } from '../interfaces/IApiResponse';
import urls from './urls';

class GiftApi {
  // Get All Gifts
  static getListGifts(): Promise<IApiResponse> {
    return axios
      .get(urls.GET_LIST_GIFTS, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } })
      .then(res => res as unknown as IApiResponse);
  }

  static getGiftReplies(): Promise<IApiResponse> {
    return axios
      .get(urls.GET_GIFT_REPLIES, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } })
      .then(res => res as unknown as IApiResponse);
  }

  // Get Received Gift of Current Logged in user
  static getGiftsReceived(): Promise<IApiResponse> {
    return axios
      .get(urls.GET_GIFTS_RECEIVED, {
        baseURL: urls.BASE_RHPURL,
        headers: { isAnonymous: false },
      })
      .then(res => res as unknown as IApiResponse);
  }

  /*
   * Gives a gift to the specified user and deducts the credits.
   * Returns current credit balance (after deduction), and other details.
   *
   * @param
   * */
  static giveGift(userId: string | number, consumablePriceID: string | number): Promise<IApiResponse> {
    const url = urls.GIVE_GIFT.replace('{UserID}', String(userId));
    return axios
      .post(url, { ConsumablePriceID: consumablePriceID }, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } })
      .then(res => res as unknown as IApiResponse);
  }

  /*
   * Redeems a received gift and credit diamonds to the current user.
   */
  static redeemReceivedGift(giftId: string | number): Promise<IApiResponse> {
    const url = urls.REDEEM_RECEIVED_GIFT.replace('{GiftID}', String(giftId));
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res as unknown as IApiResponse);
  }

  /*
   * Forfeits a received gift and refunds the coins to the client
   */
  static forfeitReceivedGift(giftId: string | number): Promise<IApiResponse> {
    const url = urls.FORFEIT_RECEIVED_GIFT.replace('{GiftID}', String(giftId));
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res as unknown as IApiResponse);
  }
}

export default GiftApi;
